export default "__VITE_ASSET__f0216687__"